import { useEffect, useRef } from 'react';

// Possible to normalize the mouse position ranging for [-1 to 1] for x and y.

interface UseMousePositionProps {
  normalize?: boolean;
}

export const useMousePosition = ({
  normalize = false,
}: UseMousePositionProps) => {
  const mousePosition = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const setFromEvent = (event: MouseEvent) => {
      mousePosition.current.x = normalize
        ? -1.0 + (2.0 * event.clientX) / window.innerWidth
        : event.clientX;

      mousePosition.current.y = normalize
        ? -1.0 + (2.0 * event.clientY) / window.innerHeight
        : event.clientY;
    };

    window.addEventListener('mousemove', setFromEvent);

    return () => {
      window.removeEventListener('mousemove', setFromEvent);
    };
  }, [normalize]);

  return mousePosition.current;
};
